export default {
  methods: {
    /* Retrieve pre-signed POST data from a dedicated API endpoint. */
    getPresignedPostData(selectedFile) {
      return new Promise(resolve => {
        var file_name = selectedFile.name;
        if (this.fileName) {
          let tmp = selectedFile.name.split(".");
          file_name = this.fileName + "." + tmp[tmp.length - 1];
        }
        const url = process.env.VUE_APP_LAMBDA_UPLOAD_URL;
        const xhr = new XMLHttpRequest();

        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(
          JSON.stringify({
            name: file_name,
            type: selectedFile.type
          })
        );
        xhr.onload = function() {
          resolve(JSON.parse(this.responseText));
        };
      });
    },
    /* Upload file to S3 with previously received pre-signed POST data. */
    uploadFileToS3(presignedPostData, file) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        Object.keys(presignedPostData.fields).forEach(key => {
          formData.append(key, presignedPostData.fields[key]);
        });

        // Actual file has to be appended last.
        formData.append("file", file);

        const xhr = new XMLHttpRequest();
        xhr.open("POST", presignedPostData.url, true);
        xhr.send(formData);
        xhr.onload = function(res) {
          if (res.status === 204) resolve();
          else reject(res.responseText);
        };
      });
    },

    process(fieldName, file, metadata, load, error, progress, abort, success) {
      var self = this;

      this.getPresignedPostData(file).then(response => {
        this.uploadFileOnUri(
          response.uploadURL,
          progress,
          load,
          error,
          file,
          abort,
          success,
          self
        );
      });
    },
    uploadFileOnUri(uri, progress, load, error, file, abort, success, self) {
      const request = new XMLHttpRequest();
      request.open("PUT", uri);
      request.upload.onprogress = e => {
        progress(e.lengthComputable, e.loaded, e.total);
      };
      request.onload = () => {
        if (request.status >= 200 && request.status < 300) {
          load(request.responseText);
        } else {
          error("Something wrong happen during the upload");
        }
      };
      let tmp = request.send;
      request.send = () => {
        tmp.call(request, file);
      };
      request.send();
      request.onloadend = () => {
        if (success) success(file.name);
        self.$emit("s3url", file.name);
      };
    }
  }
};
